<template>
  <div>
    <h1>Invitation</h1>
    <div>
      <button @click="addToken" class="w3-button w3-blue">Generate New Invitation Link</button>
    </div>
    
    <div v-if="loading">Loading...</div>
    <div v-else-if="error">Error: {{ error }}</div>
    <table v-else style="width:100%">
      <thead>
        <tr>
          <th>ID</th>
          <th>Signup Link</th>
          <th>Created At</th>
          <th>Expires At</th>
          <th>Used</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="token in tokens" :key="token.id">
          <td>{{ token.ID }}</td>
          <td><a :href="`${baseURL}/users/signup?token=${token.Token}`">
              {{ token.Token }}
          </a></td>
          <td>{{ token.CreatedAt }}</td>
          <td>{{ token.ExpiresAt }}</td>
          <td>{{ token.Used }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import config from '../config';

export default {
  name: 'TokenList',
  setup() {
    const tokens = ref([]);
    const loading = ref(true);
    const error = ref(null);

    const baseURL = window.location.origin;
    // const getBaseUrl = async () => {
    //   baseURL.value = window.location.origin;
    //   console.log("Base URL:", baseURL.value);
    // }

    const addToken = async () => {
      const jwt_token = sessionStorage.getItem("jwt");
      try {
        const response = await fetch(`${ config.apiBaseUrl }/admin/invite/generate`, {
          method: "GET",
          credentials: 'include',
          headers: {
            "Authorization": `Bearer ${jwt_token}`,
          },
        });
        if (!response.ok) {
          throw new Error('Failed to perform the action');
        }
        alert('Added!');
        fetchTokens();
      } catch (err) {
        alert(`Error: ${err.message}`);
      }
    }

    const fetchTokens = async () => {
      const jwt_token = sessionStorage.getItem("jwt");
      try {
        const response = await fetch(`${ config.apiBaseUrl }/admin/invite/list`, {
          method: "GET",
          credentials: 'include',
          headers: {
            "Authorization": `Bearer ${jwt_token}`,
          },
        });
        if (!response.ok) {
          throw new Error('Failed to fetch invitation list');
        }
        const data = await response.json();
        tokens.value = data.tokens;
      } catch (err) {
        error.value = err.message;
      } finally {
        loading.value = false;
      }
    };

    onMounted(fetchTokens);

    return {
      addToken,
      baseURL,
      tokens,
      loading,
      config,
      error
    };
  }
};
</script>

<style scoped>
/* Optional styling */
h1 {
  font-size: 2em;
  margin-bottom: 0.5em;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 1em;
  border-bottom: 1px solid #ccc;
  padding-bottom: 1em;
}
</style>
